import CityPageTemplate from "../city-template/CityPageTemplate";
import { chicagoConfig } from "./data";

export default function ChicagoPage() {
  return <CityPageTemplate config={chicagoConfig} />;
}